import {
  evalActionsSchema,
  EvalLimitItemEdgeEnum,
  EvalLimitItemOperatorEnum,
  EvalLimitItemParameterEnum,
  EvalLimitItemQuantifierTypeEnum,
  EvalLimitItemQuantifierUnitEnum,
} from "@repo/schema";
import { issueKey, tKey } from "@/core/i18n";
import { z } from "zod";

const limitItemFormSchema = z
  .object({
    id: z.string().nullable(),
    limitFrom: z.number().nullable(),
    limitTo: z.number().nullable(),
    parameter: z.enum(EvalLimitItemParameterEnum),
    operator: z.enum(EvalLimitItemOperatorEnum),
    quantifierType: z.enum(EvalLimitItemQuantifierTypeEnum),
    quantifierUnit: z.enum(EvalLimitItemQuantifierUnitEnum),
    quantifierValue: z.number(),
    targetEdge: z.enum(EvalLimitItemEdgeEnum),
    parentEdge: z.enum(EvalLimitItemEdgeEnum),
  })
  .refine((item) => item.limitFrom !== null || item.limitTo !== null, {
    ...issueKey(tKey("evaluation:form.errors.limitBoundRequired")),
    path: ["limitFrom"],
  });

export const createLimitFormSchema = z.object({
  name: z.string().min(1, issueKey(tKey("evaluation:form.errors.nameRequired"))),
  actions: evalActionsSchema,
  enabled: z.boolean(),
  targetLabelId: z.number().min(1, issueKey(tKey("evaluation:form.errors.labelRequired"))),
  targetParentLabelId: z.number().nullable(),
  limitItems: z
    .array(limitItemFormSchema)
    .min(1, issueKey(tKey("evaluation:form.errors.limitItemRequired"))),
});

export type CreateLimitFormSchema = z.infer<typeof createLimitFormSchema>;
export type LimitItemFormSchema = z.infer<typeof limitItemFormSchema>;
